<template>
  <div>

    <navbar></navbar>

    <info-modal v-on:secondary="infoModal.secondaryAction" v-on:close="infoModal.closeAction" :headline="infoModal.headline" :subline="infoModal.subline" :body="infoModal.body" :button="infoModal.closeText" :secondary="infoModal.secondaryText" ></info-modal>
    <div class="bg-header-round-small">
      <div class="container">
        <div v-if="sessionShop" >
        <h1>{{ sessionShop.name }}</h1>
        <!-- <p class="subheader">Location - <span :class="sessionShop.is_online ? 'open' : 'closed'"> {{ sessionShop.is_online ? 'Geöffnet' : 'Geschlossen' }} </span></p> -->
       </div>
      </div>
    </div>

    <div v-if="!currentLine || isLoading" class="flex items-center">
      <div class="flex-1 text-grey-darker text-center px-4 py-4 m-4">
        <cg-loader :message="''" :show="loading || connecting"></cg-loader>
      </div>
    </div>

    <div v-if="currentLine" class="container pt-0" >

      <div v-if="overlayShow" >
        <h4>Möchtest Du Deine Kamera aktivieren?</h4>
        <div class="text-center mt-4">
          <p class="text-center">So kauft es sich noch einfacher ein.</p>
          <button @click.prevent="startVideoCall(true)" class="btn icon green">
            <span><icon class="icon" name="check"></icon></span>
            <span>Ja, sehr gerne</span>
          </button>
          <button @click.prevent="startVideoCall(false)" class="btn icon orange">
            <span><icon class="icon" name="times"></icon></span>
            <span>Weiter ohne Kamera</span>
          </button>
        </div>
      </div>



      <div v-show="!isLoading" id="videolivechat">
        <div class="relative" ref="publisher">
          <div class="publisher" id="publisherContainer"></div>
          <div id="subscriberContainer" class="subscriber absolute pin-t pin-l"></div>
          <div v-if="connected" class="absolute z-10 cursor-pointer pin-b pin-l">
            <button @click.prevent="endSession()" class="btn icon orange p-4 rounded-none h-auto text-3xl">
              <icon name="phone-square"></icon>
            </button>
          </div>
        </div>
        <div class="cart-chat-box" ref="cartChatBox">
          <ul class="tabrow">
            <li :class="[activeTab === 'cart' ? 'active' : '']" @click.prevent="toggleTab('cart')"><span><icon class="icon"
                                                                                                       name="shopping-cart"></icon> Dein Einkauf</span>
            </li>
            <li :class="[activeTab === 'chat' ? 'active' : '']" @click.prevent="toggleTab('chat')"><span><icon class="icon"
                                                                                                       name="commenting-o"></icon> Chat</span>
            </li>
          </ul>
          <div :class="[activeTab === 'cart' ? 'active' : '', 'tab']" id="cart">
            <div class="overscroll-wrapper" v-if="cartItems.length !== 0">
              <table v-if="cartItems" class="live-cart">
                <thead>
                <tr>
                  <th>Produkt</th>
                  <th>Menge</th>
                  <th style="width: 30%">Preis</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in cartItems">
                  <td>{{ item.name }}</td>
                  <td>{{ formatAmount(item) }}</td>
                  <td>{{ formatPrice(item, 'bruttoSum') }}</td>
                </tr>
                </tbody>
                <tfoot>
                <tr>
                  <td>Summe <span>(Inkl. MwSt.)</span></td>
                  <td colspan="2">{{ totalPriceFormat(cart) }}</td>
                </tr>
                </tfoot>
              </table>
            </div>
            <span class="empty"
                  v-if="cartItems.length === 0">{{ sessionShop.name }} hat noch nichts in Deinen Warenkorb gelegt.</span>
          </div>
          <div :class="[activeTab === 'chat' ? 'active' : '', 'tab']" id="chat">
            <div class="chat-wrapper">
              <div id="chatContainer" class="msgs">
              <div
                  v-for="message in messages"
                  :class="message.sender.uid == account.uid ? 'vendor' : 'customer'"
              >{{ message.message }}</div>
              </div>
              <div class="form-field icon-input full">
                <span><input type="text" placeholder="Deine Nachricht" v-model="message"
                             @keyup.enter="sendMessage()" ></span>
                <span @click.prevent="sendMessage()"><icon name="chevron-circle-right" class="icon" scale="2"></icon></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <cgfooter></cgfooter>
  </div>
</template>

<script>
  import CgShopHeader from '../components/shop/CgShopHeader'
  import {mapGetters, mapActions} from 'vuex'
  import Cgfooter from '../components/CgFooter'
  import InfoModal from '../components/modals/info'
  import pusherManager from '@/assets/js/pusherManager'
  import formatting from '@/mixins/formatting.js'
  import helpers from '@/mixins/helpers.js'
  import CgLoader from '../components/menus/cgLoader'
  import Navbar from '@/components/Navbar.vue'
  import {EventBus} from '@/assets/js/event-bus.js'

  export default {
    name: 'video-chat',
    components: {
      Navbar,
      Cgfooter,
      CgShopHeader,
      InfoModal,
      CgLoader
    },
    mixins: [formatting, helpers],
    data () {
      return {
        overlayShow: true,
        activeTab: 'cart',
        message: '',
        loading: true,
        closedCall: false,
        infoModal: {
          show: false,
          headline: '',
          subline: '',
          body: '',
          closeAction: this.closeModal,
          secondaryAction: '',
          closeText: '',
          secondaryText: ''
        }
      }
    },
    mounted () {
      this.init()
    },
    created () {
      EventBus.$on('vendorDidNotCome', () => {
        this.vendorDidNotCome()
      })
      EventBus.$on('chat_message_came', () => {
        this.activeTab = 'chat'
        var container = document.getElementById('chatContainer')
        container.scrollTop = container.scrollHeight
      })
      EventBus.$on('callStopped', this.callStopped)
      EventBus.$on('recheckLineStatus', this.recheckStatus)
    },
    beforeDestroy () {
      pusherManager.sessionEnds()
      this.$store.dispatch('getLines')
      EventBus.$off('vendorDidNotCome')
      EventBus.$off('chat_message_came')
      EventBus.$off('callStopped', this.callStopped)
      EventBus.$off('recheckLineStatus')
      this.$store.commit('USER_SET_IN_LIVE_PAGE', false)
      this.$store.commit('USER_SET_CURRENT_LINE', null)
    },
    methods: {
      init () {
        this.$store.commit('USER_SET_IN_LIVE_PAGE', true)
        this.finishLoadingLine()
      },
      recheckStatus () {
        var line = this.currentLine
        if (!this.closedCall) {
          this.closedCall = true
          pusherManager.sessionEnds()
          if (this.isLineSessionFinished(line)) {
            this.showFinishedMessage()
          } else if (this.isLineSessionCanceled(line)) {
            this.showCancelMessage()
          } else {
            this.showAwayMessage()
          }
        }
      },
      finishLoadingLine () {
        if (!this.currentLine) {
          this.showAwayMessage()
        } else if (!this.currentLine.is_vendor_in_channel) {
          this.showCancelMessage()
        }
      },
      vendorDidNotCome () {
        if (this.waitingVendor) {
          setTimeout(function (vm) {
            if (vm.waitingVendor) {
              vm.showCancelMessage()
            }
          }, 3000, this)
        }
      },
      showAwayMessage () {
        var shopText = this.currentLine ? 'bei ' + this.currentLine.shop.name + ' ' : ''
        this.infoModal = {
          show: true,
          headline: 'Ups',
          subline: 'Da ist etwas schief gelaufen',
          body: 'Du bist gleich wieder an der Reihe und kannst Deinen Einkauf ' + shopText + 'fortsetzten',
          closeAction: this.goHome,
          closeText: 'Weiter',
          secondaryAction: this.goHome,
          secondaryText: ''
        }
        EventBus.$emit('toggleInfoModal')
      },
      showFinishedMessage () {
        var shopText = this.currentLine ? this.currentLine.shop.name + ' ' : 'Shop '
        var shopName = this.currentLine ? this.currentLine.shop.name + ' ' : 'Der Händler '
        this.infoModal = {
          show: true,
          headline: 'Vielen Dank für Deinen Einkauf!',
          subline: shopName + 'hat die Video-Verbindung beendet.',
          body: 'Um Deine Bestellung abzuschließen, überprüfe bitte den Warenkorb und gehe „Zur Kasse“. Wünschst Du eine Änderung Deines Warenkorbes, so stelle Dich bitte erneut an und teile dies dem Händler (' + shopName + ') mit oder kontaktiere uns.',
          closeAction: this.goCheckout,
          closeText: 'Zur Kasse gehen',
          secondaryAction: this.backInLine,
          secondaryText: 'Beim ' + shopText + 'wieder anstellen'
        }
        EventBus.$emit('toggleInfoModal')
      },
      showCancelMessage () {
        var shopText = this.currentLine ? this.currentLine.shop.name + ' ' : 'Der Händler '
        this.infoModal = {
          show: true,
          headline: shopText + 'braucht noch einen Moment und ist gleich für Dich da.',
          subline: '',
          body: '',
          closeAction: this.goHome,
          closeText: 'Weiter',
          secondaryAction: this.goHome,
          secondaryText: ''
        }
        EventBus.$emit('toggleInfoModal')
      },
      closeModal () {
        this.infoModal.show = false
        EventBus.$emit('toggleInfoModal')
      },
      goHome () {
        this.goTo('home')
      },
      backInLine () {
        this.getInLine({shop: this.currentLine.shop.uid})
        this.goHome()
      },
      goCheckout () {
        this.goTo('checkout', {'cart': this.currentLine.cart.uid})
      },
      startVideoCall (withVideo) {
        this.$store.commit('USER_SET_SHARE_VIDEO', withVideo)
        var channel = this.currentLine.channels.salessession
        if (!channel) {
          channel = this.$store.getters.user_get_session_channel
        }
        this.$store.commit('WAITING_FOR_VENDOR', false)
        pusherManager.initSaleSessionChannel(channel)
        this.overlayShow = false
        this.loading = false
      },
      sendMessage () {
        if (this.sessionShop) {
          var receiver = this.currentLine.vendor.uid
          var self = this
          self.sendChatMessage({
            cart: self.currentLiveCart.uid,
            message: self.message,
            sender: self.account.uid,
            receiver: receiver,
            cb: () => {
              self.message = ''
            }
          })
        }
      },
      toggleTab (tab) {
        console.log('toggle tab', tab)
        this.activeTab = tab
      },
      callStopped (line) {
        console.log('call stopped called ', line, this.closedCall)
        if (!this.closedCall) {
          this.closedCall = true
          if (line && this.currentLine) {
            if (this.currentLine && this.currentLine.uid === line.uid) {
              var self = this
              this.getLine({
                line: line.uid,
                cb (responseLine) {
                  if (self.isLineSessionFinished(responseLine)) {
                    self.showFinishedMessage()
                  } else {
                    self.showCancelMessage()
                  }
                },
                errorCb () {
                  self.showCancelMessage()
                }
              })
            }
          } else {
            this.showAwayMessage()
          }
        }
      },
      endSession () {
        var vm = this
        vm.$dialog.confirm('Möchtest du ablegen? Der Einkauf ist noch nicht abgeschlossen worden').then(() => {
          pusherManager.sessionEnds()
          vm.goHome()
        })
      },
      ...mapActions([
        'sendChatMessage',
        'getLine',
        'getLines',
        'getInLine'
      ])
    },
    computed: {
      isLoading () {
        return this.connecting || this.loading
      },
      ...mapGetters({
        waitingVendor: 'user_get_waiting_vendor',
        lines: 'user_get_lines',
        currentLiveCart: 'user_get_current_live_cart',
        cart: 'user_get_current_live_cart',
        cartItems: 'user_get_current_live_cart_items',
        messages: 'user_get_session_messages',
        account: 'auth_get_account',
        sessionShop: 'user_get_session_shop',
        currentLine: 'user_get_current_line',
        sessionUnexpectedClose: 'user_session_unexpected_close',
        connected: 'user_get_current_line_status',
        connecting: 'user_connecting',
        messageCame: 'user_new_message'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/VideoChat.vue